import React from 'react';
import './TicketTabs.css'

const TicketTabs = ({ activeTab, setActiveTab, onAddNote }) => (
  <div className="ticket-tabs">
    <button 
      className={`tab ${activeTab === 'ticket' ? 'active' : ''}`}
      onClick={() => setActiveTab('ticket')}
    >
      Ticket
    </button>
    <button 
      className={`tab ${activeTab === 'history' ? 'active' : ''}`}
      onClick={() => setActiveTab('history')}
    >
      History
    </button>
    <button 
      className={`tab ${activeTab === 'notes' ? 'active' : ''}`}
      onClick={() => setActiveTab('notes')}
    >
      Notes
    </button>
    <div className="bar-div"></div>
    <button className="tab delete">Delete Ticket</button>
    <button className="tab add-note" onClick={onAddNote}>
      Add note
    </button>
  </div>
);

export default TicketTabs;